import React, { Fragment, useEffect } from 'react'
import CourseCard from '../components/cards/CourseCard';
import CourseList from '../providers/courses/CoursesList';
import Footer from './Sections/Footer';
import Header from './Sections/Header';

const HomeScreen = () => {

    return (
        <Fragment>
            <div id="wrapper" class="bg-white">

                <Header />

                <div class="nav-overlay uk-navbar-left uk-position-relative uk-flex-1 bg-grey uk-light p-2" hidden={true} style={{ zIndex: "10000" }}>
                    <div class="uk-navbar-item uk-width-expand" style={{ minHeight: "60px" }}>
                        <form class="uk-search uk-search-navbar uk-width-1-1">
                            <input class="uk-search-input" type="search" placeholder="Recherche..." autofocus="" />
                        </form>
                    </div>
                    <a class="uk-navbar-toggle" uk-close="" uk-toggle="target: .nav-overlay; animation: uk-animation-fade" href="#"></a>
                </div>

                <div class="page-content">

                    <div class="home-hero" style={{ background: 'url('+require("../assets/images/home-hero.png")+') no-repeat', backgroundSize: "cover" }} data-src="../assets/images/home-hero.png" uk-img="">
                        <div class="uk-width-1-1">
                            <div class="page-content-inner uk-position-z-index">
                                <h1 style={{color: "white"}}>Apprennez HTML , CSS , Android <br /> Apps et plus...</h1>
                                <h4 class="my-lg-4" style={{color: "white"}}> Apprennez à développer des site Web et Applications Mobile, <br /> écrire du code ou commencer un business</h4>
                                <a href="#" class="btn btn-default" style={{color: "white"}}>Free trailer </a>
                            </div>
                        </div>
                    </div>

                    <div class="section">
                        <div class="page-content-inner">

                            <div class="section-small text-md-left text-center">
                                <div class="uk-child-width-1-2@m uk-gird-large uk-flex-middle" uk-grid="">
                                    <div>
                                        <img src="../assets/images/feature.png" alt="" />
                                    </div>
                                    <div>
                                        <h2>Apprennez à coder n'importe quand <br /> et n'importe où </h2>
                                        <p> Commencez juste avec votre nom et votre email. C'est simple</p>
                                        <a href="#" class="btn btn-soft-light"> Commencer maintenant </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="section-small delimiter-top">

                        <div class="container-small">
                            <div class="text-center mb-5">
                                <h3> Découvrez nos nouveautés </h3>
                                <h5> Avec notre catalogue grandissant de plus de 30 programmes allant du niveau débutant au niveau avancé</h5>
                            </div>
                            <div class="course-grid-slider mt-lg-5" uk-slider="finite: true">
                                <div class="uk-slider-container pb-3" style={{width: "98%"}}>
                                    <ul class="uk-slider-items uk-child-width-1-2@s uk-child-width-1-3@m uk-grid">
                                        {CourseList.map(course => <CourseCard course={course} />)}
                                    </ul>

                                    <a class="uk-position-center-left uk-position-small uk-hidden-hover slidenav-prev" href="#" uk-slider-item="previous"></a>
                                    <a style={{right: "15px"}} class="uk-position-center-right uk-position-small uk-hidden-hover slidenav-next" href="#" uk-slider-item="next"></a>

                                </div>
                            </div>

                            <div class="text-center">
                                <a href="#" class="btn btn-soft-light btn-small btn-circle"> Voir plus de cours </a>
                            </div>
                        </div>
                    </div>

                    <div class="section text-center">
                        <div class="page-content-inner">

                            <h2 class="mb-4"> Nous avons couver les aspects techniques. </h2>
                            <img src="../assets/images/feature-2.png" alt="" class="my-lg-5" />

                        </div>
                    </div>

                    <div class="section bg-white">
                        <div class="container-small">
                            <h2 class="text-center my-lg-6"> Essayez pour 14 jours </h2>
                            <form class="uk-grid-small d-flex align-items-end" uk-grid="">
                                <div class="uk-width-1-3@s">
                                    <div class="uk-form-label">Email </div>
                                    <input class="uk-input" type="text" placeholder="Entrez votre adresse email" />
                                </div>
                                <div class="uk-width-1-3@s">
                                    <div class="uk-form-label">Mot de passe </div>
                                    <input class="uk-input" type="password" placeholder="******" />
                                </div>
                                <div class="uk-width-1-3@s">
                                    <button class="btn  btn-light btn-lg"> Débuter l'essai gratuit </button>
                                </div>
                                <div class="uk-width-1-1@s">
                                    <label>
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" id="customCheck1" type="checkbox" />
                                            <label class="custom-control-label" for="customCheck1">
                                                <span class="checkmark uk-text-small"> J'accepte les </span>
                                                <a href="pages-terms.html" target="_blank"
                                                    class="uk-text-bold uk-text-small uk-link-reset">
                                                    Termes et Conditions </a>
                                            </label>
                                        </div>
                                    </label>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>

                <Footer />

            </div>
        </Fragment>
    )
}

export default HomeScreen
